import React, { useEffect, useState } from 'react'
import {PrismicRichText} from "@prismicio/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUpRightFromSquare} from "@fortawesome/free-solid-svg-icons/faUpRightFromSquare";
import {faDownload} from "@fortawesome/free-solid-svg-icons/faDownload";
import { useLocation } from "@reach/router";

// components
import CustomLink from "../../../components/CustomLink";

// assets and utils
import useWindowSize from "../../../hooks/useWindowSize";
import {downloadMedia, getButtonCustomStyles, getFontSize} from "../../../assets/js";
import { useConsent } from "../../../components/ConsentContext";

// constants
import { COLOR } from "../../../constants/colors";
import * as images from "../../../assets/images/icons";

// data-layer
import { setDownloadClickedEvent, setLearnMoreClickedEvent, videoStartEvent } from "../../../assets/js/data-layer";
import {getFullURL} from '../../../assets/js/functions';

export const ImageSlide = ({item,setShow,setModalDetails,setIsYouTubeVideo}) => {
  // console.log(item)
  const location = useLocation()
  const consentAccepted = useConsent()

  const { width } = useWindowSize()
  const CTALink = item.cta_link?.url || ''

  const showButton = item.show_button
  const showSubTitle = item.show_subtitle
  const showTitle = item.show_title
  const showParagraph = item.show_paragraph
  const showContentBlock = showSubTitle || showTitle || showParagraph
  const transitionToWaveImage = item?.show_transition
  const waveImage = {
                  src: width < 768 ? item?.transitionimage?.thumbnails?.Transition_image_mobile?.url:item?.transitionimage?.url,
                  alt: item.transitionimage?.alt
                  }

  const reverseButtonClass = item.reverse_content ? "hero-carousel__cta-button--right" : "hero-carousel__cta-button--left"
  const reverseContentClass = item.reverse_content ? "hero-carousel__content--right" : "hero-carousel__content--left"

  // Links
  const isDownloadLink = item.cta_download_button
  const isTargetBlank = item.cta_button_open_in_new_tab
  const target = isTargetBlank ? '_blank' : '_self'

  // Text
  const subTitle = item.subtitle?.richText || []
  const subTitleTextColor = item.subtitle_text_color || COLOR.BLACK
  const subTitleFontSizeDesktop = item.subtitle_font_size_desktop || '38'
  const subTitleFontSizeMobile = item.subtitle_font_size_mobile || '20'
  const subTitleFontSize = getFontSize(width, subTitleFontSizeDesktop, subTitleFontSizeMobile)


  const title = item.title?.richText || []
  const titleTextColor =item.title_text_color || COLOR.BLACK
  const titleTextFontSizeDesktop = item.title_font_size_desktop || '82'
  const titleTextFontSizeMobile = item.title_font_size_mobile || '40'
  const titleTextFontSize = getFontSize(width, titleTextFontSizeDesktop, titleTextFontSizeMobile)

  const textAlignmentMobile = item.text_alignment_mobile || 'center'
  const textAlignmentDesktop = item.text_alignment_desktop || 'center'
  const paragraph = item.paragraph?.richText || []
  const paragraphTextColor = item.paragraph_text_color || COLOR.BLACK
  const paragraphFontSizeDesktop = item.paragraph_font_size_desktop || '24'
  const paragraphFontSizeMobile = item.paragraph_font_size_mobile || '20'
  const paragraphFontSize = getFontSize(width, paragraphFontSizeDesktop, paragraphFontSizeMobile)

  const textAlignment = width < 768 ? textAlignmentMobile:textAlignmentDesktop
  // text content styles
  const subTitleStyles = {
    color: subTitleTextColor,
    fontSize: subTitleFontSize

  }

  const titleStyles = {
    color: titleTextColor,
    fontSize: titleTextFontSize
  }

  const paragraphStyles = {
    color: paragraphTextColor,
    fontSize: paragraphFontSize,
    display: "inline-block",
    width: "100%",
    overflowWrap: "break-word"
  }

  // image
  const image = {
    src: width < 768 ? item.banner?.thumbnails?.mobile.url : item.banner?.url,
    alt: item.banner?.alt
  }

  // CTA Button
  const ctaButton = {
    text: item.cta_button_text?.text || '',
  }

  const ctaDownloadButtonFileName = item.cta_download_file_name || ''
  const ctaButtonDownloadLink = item.cta_download_button_file?.url || ''

  // CTA Styles
  const buttonColorSet = {
    color: item.cta_button_text_color,
    bg: item.cta_button_bg_color,
    bgT: item.cta_button_bg_color_transparency,
    border: item.cta_button_border_color,
    colorHover: item.cta_button_text_color_hover,
    bgHover: item.cta_button_bg_color_hover,
    bgHoverT: item.cta_button_bg_color_hover_transparency,
    borderHover: item.cta_button_border_color_hover,
  }

  const { ctaButtonStyle } = getButtonCustomStyles(buttonColorSet)
  const alighmentStyle = {
    //maxWidth: textAlignment =="center"?'':"700px",
    margin:textAlignment == "center"?'auto':'',
    marginLeft:textAlignment == "right"?'auto':'',
    marginRight:textAlignment == "left"?'auto':'',
    textAlign: textAlignment,
    flexDirection:width < 768 ? "column-reverse" : (textAlignment =="center"?"column-reverse"
                :(textAlignment =="right" ? "row-reverse"
                  :""))
  }



  const onCloseBtnClick=() => {
    setShow(false)
  }
  const onPlayBtnClick = (modalDetails) => {
      setShow(true)
      const dataLayer={
        videoTitle:item?.video_title || '',
        videoURL:item?.youtube_video ? modalDetails : modalDetails?.url?.replace("/videos/", ""),
        videoProvider: item?.youtube_video ? 'Youtube':'MP4'
      }
      videoStartEvent(dataLayer,consentAccepted)
      setModalDetails(modalDetails)
      setIsYouTubeVideo(isYouTubeVideo)
  }
  const cardBadgeText = item.label_text?.text ;
  const badgeColor = item.label_color ? item.label_color : "#C6D431"
  const isYouTubeVideo = item.youtube_video
  const youTubeSrc = item.youtube_link || ''
  const githubVideoFilename = item?.github_video_filename_desktop;
  const githubVideoFilenameTrimmed = githubVideoFilename?.trim() || ''
  const video = githubVideoFilenameTrimmed ? `/videos/${githubVideoFilenameTrimmed}` : ''
  const content_classname = item.content_type_video_modal && width < 768 ?
   'hero-carousel-content':(transitionToWaveImage && width < 768 ?'hero-carousel-content wave-padding-bottom-mobile':(transitionToWaveImage ?'hero-carousel-content wave-padding-bottom-desktop':'hero-carousel-content'))

  const isBrowser = typeof window !== "undefined"
  const [openNewWindow,setOpenNewWindow]=useState(false)
  useEffect(() => {
    if(isBrowser) {
      if(window.location.pathname.endsWith("/nobail")) {
        if(item.cta_link?.url?.startsWith("http://") || item.cta_link?.url?.startsWith("https://")) {
          setOpenNewWindow(true);
        }
      }
    }
  },[location?.pathname])
  return (<>

        <div className="hero-carousel__img-container">
        <CustomLink to={CTALink}
        isNewWindow={openNewWindow}
        >
        {cardBadgeText && <span className="hero-tag" style={{background:`${badgeColor}`}}>{cardBadgeText}</span>}
        <img className='hero-carousel__img' src={image.src} alt={image.alt}
        onClick={() => {
          const dl = {
            name: image?.alt,
            url: getFullURL(item?.cta_link?.url),
            content: "hero",
            type: "navigation",
          }
          setLearnMoreClickedEvent(dl, consentAccepted)
        }}
          />
        </CustomLink>



        {transitionToWaveImage && !(item.content_type_video_modal) && (
          <div className={`wave-overlay-hero ${transitionToWaveImage ? 'animate-wave-hero' : ''}`}>
            <img src={waveImage.src} alt={waveImage.alt?waveImage.alt:"Wave overlay"} />
          </div>
        )}
      </div>


        <div className = {content_classname} style={alighmentStyle}>

          <div className={"hero-content-info"} >
              { showContentBlock && <>
                {showTitle && <h1 style = {{lineHeight:width < 768?"":"65px"}}>
                  {title.map((row) => {
                    return <span key={row.text} style={titleStyles}>
                      <PrismicRichText field={[row]}/><br/>
                    </span>
                  })
                  }
                </h1>}

                {showSubTitle && <h2 style = {{lineHeight:width < 768?"":"65px"}}>
                  {subTitle.map((row) => {
                    return <span key={row.text} style={subTitleStyles}>{row.text}<br/></span>
                  })
                  }
                </h2>}

                {showParagraph && <p>
                  {paragraph.map((row) => {
                    return <span key={row.text} style={paragraphStyles}>{row.text}<br/></span>
                  })
                  }
                </p>}
              </>}

              {showButton && <>

                {!isDownloadLink && <CustomLink to={CTALink} title={ctaButton.text}
                                        onClick={()=> {
                                          const dl = {
                                            page_name: location.pathname.split("/").pop(),
                                            referrer: location.pathname,
                                            name: ctaButton.text,
                                            url: getFullURL(CTALink),
                                            type:location.pathname.split("/").pop()==="music" ? "navigation" : "CTA Button",
                                            content:"hero"
                                          }
                                          setLearnMoreClickedEvent(dl, consentAccepted)
                                        } }
                                      className={`hero-carousel-content--button`}
                                      style={ctaButtonStyle} target={target}>
                  {ctaButton.text}
                  {isTargetBlank && <FontAwesomeIcon icon={faUpRightFromSquare} className='ml-2'/>}
                </CustomLink>}

                {isDownloadLink &&
                    <button title={ctaButton.text} className={`hero-carousel-content--button`}
                            style={ctaButtonStyle}
                            onClick={() => {
                              downloadMedia(ctaButtonDownloadLink, ctaDownloadButtonFileName)

                              // 'download_clicked' data layer event
                              setDownloadClickedEvent({
                                fileName: ctaDownloadButtonFileName,
                                clickUrl: ctaButtonDownloadLink,
                                clickText: ctaButton.text,
                                pageUrl: location.href
                              }, consentAccepted)
                            }}
                    >
                      {ctaButton.text}
                      <FontAwesomeIcon icon={faDownload} className='ml-2'/>
                    </button>}
              </>}

          </div>
        {item.content_type_video_modal &&
          <div className={showContentBlock ? "video-item-play-btn-top":"video-item-play-btn"}>
                 <img src={images.playBtnPng} alt="Play Button" className="play-btn" onClick={() => onPlayBtnClick({url: isYouTubeVideo ? youTubeSrc :video,title:item?.video_title || ''})} />
          </div>
        }
       </div>

      </>
  )
}